export enum PointerType {
  Mouse = 'mouse',
  Pen = 'pen',
  Touch = 'touch',
}
